import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

export const SignupForm: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()

  // Check for invitation token in URL
  const searchParams = new URLSearchParams(location.search)
  const invitationToken = searchParams.get('token')

  // Redirect if already logged in
  useEffect(() => {
    if (user) {
      const from = (location.state as any)?.from?.pathname || '/dashboard'
      navigate(from, { replace: true })
    }
  }, [user, navigate, location])

  // Redirect to login with invitation token if present
  useEffect(() => {
    const from = (location.state as any)?.from?.pathname || '/dashboard'
    const loginPath = invitationToken 
      ? `/auth/login?token=${invitationToken}&from=${encodeURIComponent(from)}`
      : `/auth/login`
    
    navigate(loginPath, { replace: true })
  }, [navigate, location, invitationToken])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-sm text-gray-600">
            Redirecting to Slack authentication...
          </p>
        </div>
      </div>
    </div>
  )
} 